"use client"; // This is required at the top for client-side rendering

import React, { useState, useEffect } from "react";
import ArrowRight from "@/assets/svgs/faqCategory/ArrowRight";
import SearchIcon from "@/assets/svgs/SearchIcon";
import Link from "next/link";
import NeedSupport from "@/common/NeedSupport";
import { topicsData } from "../../data";
import {
  highlightText,
  getFilteredSubpages,
} from "@/app/helpers/getSearchResults";
import "../../FAQ.css";
import "../FAQCategory.css";
import "./FAQSubcategory.css";

function FAQSubCategory({ category, subcategory }) {
  const activeCategory = topicsData.find(
    (item) => item.link === `/${category}`
  );

  const activeSubcategory = activeCategory?.subpages?.find(
    (sub) => sub.link === `/${subcategory}`
  );

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const filteredSubpages = getFilteredSubpages(topicsData, debouncedSearchTerm);

  return (
    <div className="FAQ-category">
      <div className="FAQ-category-wrapper">
        <div className="FAQ-c-top">
          <div className="FAQ-c-top-left">
            <Link href="/faq" className="FAQ-c-top-left-link">
              Hilfezentrum
            </Link>

            <ArrowRight className="FAQ-c-top-left-arrow-icon" />

            <Link href={`/faq/${category}`} className="FAQ-c-top-left-link">
              {activeCategory?.title}
            </Link>

            <ArrowRight className="FAQ-c-top-left-arrow-icon desktop" />

            <Link
              href={`/faq/${category}/${subcategory}`}
              className="FAQ-c-top-left-link desktop"
            >
              {activeSubcategory?.title}
            </Link>
          </div>
          <div className="FAQ-c-top-right">
            <div className="FAQ-input-wrapper">
              <input
                type="text"
                placeholder="Suche..."
                className="search-input transition"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <SearchIcon className="search-icon" />
            </div>

            {debouncedSearchTerm && (
              <div className="FAQCategory-results">
                {filteredSubpages.length > 0 ? (
                  filteredSubpages.map((faq) => (
                    <Link
                      href={`/faq${faq.link}${faq.subpageLink}`}
                      key={faq.id}
                    >
                      <div key={faq.id} className="FAQCategory-item transition">
                        <h2>{highlightText(faq.title, searchTerm)}</h2>
                        <p className="Search-result-text">
                          FAQ {" > "}
                          {faq.link.replace(/^\/+/, "")} {" > "}
                          {faq.subpageLink.replace(/^\/+/, "")}
                        </p>
                      </div>
                    </Link>
                  ))
                ) : (
                  <div className="FAQ-item">
                    <p>Keine Ergebnisse gefunden.</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="FAQ-subcategory-wrapper">
        <h1>{activeSubcategory?.title}</h1>
        <div className="FAQ-subcategory-text">{activeSubcategory?.text}</div>
      </div>

      <NeedSupport />
    </div>
  );
}

export default FAQSubCategory;
